export default {
      id: "ic_fleche_gauche-usage",
      viewBox: "0 0 50 50",
      url: "../dist/images/" + "sprite.svg#ic_fleche_gauche-usage",
      toString: function () {
        return this.url;
      }
    }